import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { handleHiraganaKanaChange } from "@services/ErrorHandling";
import { UserFieldErrorMessages } from "@constants/Errors";
import { handleNameCheck } from "@services/ErrorHandling";
import { USER } from "@types/user";

type UserNameCardProps = {
  userData: USER;
  errors: any;
  updateUserData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
};

export const UserNameCard = ({
  userData,
  errors,
  updateUserData,
  updateError,
}: any) => {
  return (
    <div className="w-full md:w-3/5">
      <h2 className="mb-5 label-light-blue-xl">
        氏名{" "}
        <span className="text-base text-zinc-400 font-bold">
          （姓・名いずれか必須）
        </span>{" "}
        <span className="text-red-500">*</span>
      </h2>
      <div className="flex gap-2 md:gap-9 mb-2 w-full">
        <div className="flex-1">
          <TextInputField
            label="姓"
            providedClassName="form-text-field-border-full"
            labelClassName="label-light-blue-md"
            value={userData?.last_name}
            placeholder="山田"
            onChange={(e) =>
              handleNameCheck(
                "last_name",
                e.target.value,
                updateUserData,
                updateError,
              )
            }
          />
        </div>
        <div className="flex-1">
          <TextInputField
            label="名"
            providedClassName="form-text-field-border-full"
            labelClassName="label-light-blue-md"
            value={userData?.first_name}
            placeholder="太郎"
            onChange={(e) =>
              handleNameCheck(
                "first_name",
                e.target.value,
                updateUserData,
                updateError,
              )
            }
          />
        </div>
      </div>
      {(errors.last_name || errors.first_name) && (
        <p className="text-red-500">
          {UserFieldErrorMessages.keycloakNameError}
        </p>
      )}

      <div className="mt-5 divider" />

      <h2 className="mb-5 label-light-blue-xl">ふりがな</h2>
      <div className="flex gap-2 md:gap-9 mb-2">
        <div className="flex-1">
          <TextInputField
            label="せい"
            providedClassName="form-text-field-border-full"
            labelClassName="label-light-blue-md"
            value={userData?.last_furigana_name}
            placeholder="やまだ"
            onChange={(e) =>
              handleHiraganaKanaChange(
                "last_furigana_name",
                e.target.value,
                updateUserData,
                updateError,
              )
            }
          />
        </div>
        <div className="flex-1">
          <TextInputField
            label="めい"
            providedClassName="form-text-field-border-full"
            labelClassName="label-light-blue-md"
            value={userData?.first_furigana_name}
            placeholder="たろう"
            onChange={(e) =>
              handleHiraganaKanaChange(
                "first_furigana_name",
                e.target.value,
                updateUserData,
                updateError,
              )
            }
          />
        </div>
      </div>
      {(errors.last_furigana_name || errors.first_furigana_name) && (
        <p className="text-red-500">
          {" "}
          {UserFieldErrorMessages.nameHiraganaError}
        </p>
      )}
      <div className="mt-5 divider" />
    </div>
  );
};
